enum GroupedRequestGroup {
   squadFilter = 'squad-filter',
}

enum GroupedRequestPage {
   boardDetails = 'board-details',
}

export { GroupedRequestGroup, GroupedRequestPage };
